import { resolveMissingLocalePath } from '../../funnels/routing';

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return;

  const funnel = useFunnelContext().value;
  if (funnel === 'baseline') return;

  const prefix = `/${funnel}`;
  if (to.path !== prefix && !to.path.startsWith(`${prefix}/`)) {
    return navigateTo({ path: `${prefix}${to.path}`, query: to.query, hash: to.hash });
  }

  const localized = resolveMissingLocalePath(to.path, funnel);
  if (!localized || !useRouter().resolve(localized).matched.length) return;

  return navigateTo({ path: localized, query: to.query, hash: to.hash }, { replace: true });
});
